import { useSite } from "../context/SiteContext";
import { Seo } from "../components/site/Seo";
import { PageHeader } from "../components/site/PageHeader";
import { ReviewCard } from "../components/site/ReviewCard";
import { GoogleRating } from "../components/site/GoogleRating";
import { CampaignBanner } from "../components/site/CampaignBanner";
import { ContactSection } from "../components/site/ContactSection";

export default function ReviewsPage() {
  const { reviews } = useSite();
  const crumbs = [{ to: "/", label: "Ana Sayfa" }, { to: "/yorumlar", label: "Misafir Yorumları" }];
  return (
    <>
      <Seo
        title="Lunessa Spa Masaj Yorumları | Sivas"
        description="Lunessa Spa Masaj misafir yorumları: Sivas’ta masaj, spa, sauna ve jakuzi deneyimlerini paylaşan misafirlerimizin görüşleri."
        path="/yorumlar"
        breadcrumbs={crumbs}
      />
      <PageHeader eyebrow="Yorumlar" h1="Misafir Yorumları" intro="Salonumuzu ziyaret eden misafirlerimizin deneyimleri, hizmet anlayışımızı en iyi anlatan geri bildirimler." image="/images/lunessa-sivas-spa-dinlenme-alani.webp" imageAlt="lunessa-sivas-masaj-misafir-yorumlari" crumbs={crumbs} />
      <section className="container-lux py-16 lg:py-24" data-testid="reviews-page">
        <div className="mb-10">
          <GoogleRating testId="page-google-rating" />
        </div>
        <div className="masonry">
          {reviews.map((r, i) => (
            <ReviewCard key={r.id} r={r} testId={`review-card-${i}`} />
          ))}
        </div>
      </section>
      <CampaignBanner />
      <ContactSection />
    </>
  );
}
